import { Routes, Route, Navigate } from 'react-router-dom';
import { ROUTES } from '@shared/config/routes';
import { LoginPage } from '@pages/login';
import { ForgotPasswordPage } from '@pages/forgot-password';
import { RegisterPage } from '@pages/register';
import { VerifyPage } from '@pages/verify';
import { DashboardPage } from '@pages/dashboard';
import { ProfilePage } from '@pages/profile';
import { ProductListPage, ProductNewPage, ProductEditPage } from '@pages/products';
import { BuyRequestsFeedPage, BuyRequestDetailPage, RespondPage } from '@pages/buy-requests';
import { QuotesPage } from '@pages/quotes';
import { OrdersListPage, OrderDetailPage } from '@pages/orders';
import { ShipmentCalculatorPage } from '@pages/shipments';
import { ChatsPage } from '@pages/chats';
import { CrmPage } from '@pages/crm';
import { NotificationsPage } from '@pages/notifications';
import {
  SettingsAccountPage,
  SettingsSecurityPage,
  SettingsIndexRedirect,
} from '@pages/settings';
import { RequireAuth, RequireAnonymous } from './guards';
import { AppShell } from '@widgets/app-shell';

export function AppRouter() {
  return (
    <Routes>
      <Route
        path={ROUTES.login}
        element={
          <RequireAnonymous>
            <LoginPage />
          </RequireAnonymous>
        }
      />
      <Route
        path={ROUTES.forgotPassword}
        element={
          <RequireAnonymous>
            <ForgotPasswordPage />
          </RequireAnonymous>
        }
      />
      <Route
        path={ROUTES.register}
        element={
          <RequireAnonymous>
            <RegisterPage />
          </RequireAnonymous>
        }
      />
      <Route
        path={ROUTES.verify}
        element={
          <RequireAnonymous>
            <VerifyPage />
          </RequireAnonymous>
        }
      />

      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path={ROUTES.root} element={<DashboardPage />} />
        <Route path={ROUTES.profile} element={<ProfilePage />} />
        <Route path={ROUTES.products} element={<ProductListPage />} />
        <Route path={ROUTES.productNew} element={<ProductNewPage />} />
        <Route path="/products/:id/edit" element={<ProductEditPage />} />
        <Route path={ROUTES.buyRequests} element={<BuyRequestsFeedPage />} />
        <Route path="/buy-requests/:id" element={<BuyRequestDetailPage />} />
        <Route path="/buy-requests/:id/respond" element={<RespondPage />} />
        <Route path={ROUTES.quotes} element={<QuotesPage />} />
        <Route path={ROUTES.orders} element={<OrdersListPage />} />
        <Route path="/orders/:id" element={<OrderDetailPage />} />
        <Route path="/shipments/calculator" element={<ShipmentCalculatorPage />} />
        <Route path={ROUTES.chats} element={<ChatsPage />} />
        <Route path="/chats/:id" element={<ChatsPage />} />
        <Route path={ROUTES.crm} element={<CrmPage />} />
        <Route path={ROUTES.notifications} element={<NotificationsPage />} />
        <Route path={ROUTES.settings} element={<SettingsIndexRedirect />} />
        <Route path={ROUTES.settingsAccount} element={<SettingsAccountPage />} />
        <Route path={ROUTES.settingsSecurity} element={<SettingsSecurityPage />} />
      </Route>

      <Route path="*" element={<Navigate to={ROUTES.root} replace />} />
    </Routes>
  );
}
